import React from "react";
import AudioPlaylist from "./AudioPlaylist";

function Music() {
  return (
    <div className="text-center">
      <AudioPlaylist />
    </div>
  );
}

export default Music;
